import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	modalData: {
		visible: false,
		type: 0, // 0 = Confirmação | 1 = Notificação
		status: 0, // 0 = error | 1 = success
	},
	pageData: {
		id: "",
		nome: "",
		descricao: "",
		subSite: {
			id: "",
			siteId: "",
			name: "",
			shortName: "",
			regionId: "",
			address: "",
			zipCode: "",
			city: "",
			telephone: "",
			description: "",
			code: "",
			isActive: true,
			email: null,
			subRegionId: null,
			approvalDate: "",
		},
		duracao: "",
		durationSpan: "",
		programArea: {
			id: "",
			code: "",
			name: "",
			description: "",
			parent: "",
			parentAreaId: "",
			siteId: "",
			level: "",
			structure: "",
			order: "",
			isReadOnly: true,
			subSiteId: "",
		},
		ratingEval: null,
		ratingEvalCount: "",
		programa: "",
		trainingType: "",
		courseVersions: [
			{
				id: "",
				siteId: "",
				courseId: "",
				name: "",
				areaId: null,
				description: "",
				duration: "",
				modalityId: "",
				program: "",
				minimumSeats: "",
				maximumSeats: "",
				vendorId: "",
				typologyId: "",
				htmlDescription: null,
				htmlProgram: null,
				statusId: "",
				shortProgram: "",
				course: null,
			},
		],
		catalogNode: {
			id_Catalogo: "",
			nome: "",
		},
	},
};

const CatalogDetailsSlice = createSlice({
	name: "CatalogDetails",
	initialState: initialState,
	reducers: {
		updatePageData(state, action) {
			// console.log("update CatalogDetails");
			// console.log(action);

			state.pageData = action.payload;
		},
		resetModalData(state, action) {
			// console.log("update CatalogDetails");
			// console.log(action);

			state.modalData.visible = false;
			state.modalData.type = 0;
			state.modalData.status = 0;
		},
		cenas(state, action) {
			console.log("update Cenas");
			console.log(action);

			state.modalData.visible = true;
		},		
	},
});

export const CatalogDetailsActions = CatalogDetailsSlice.actions;

export default CatalogDetailsSlice;
